import { csx } from '@vtex/admin-ui'

const styles = {
  helpText: csx({
    marginTop: '$space-2',
    display: 'block',
    ':empty': {
      display: 'none',
    },
  }),
}

export default styles
